import { motion } from "framer-motion";
import { Bike, CreditCard, Video } from "lucide-react";

const ITEMS = [
  {
    id: "scooter",
    icon: Bike,
    title: "In scooter nel traffico",
    desc: "Superiamo il traffico di Corso Umberto e della Tangenziale: 90 minuti garantiti, zaino tecnico attrezzato.",
  },
  {
    id: "cashless",
    icon: CreditCard,
    title: "Zero contante",
    desc: "Solo digitale/POS: SumUp, Apple Pay, Satispay, bonifico istantaneo. Scontrino o fattura immediata.",
  },
  {
    id: "video",
    icon: Video,
    title: "Pre-diagnosi via Video",
    desc: "Mandaci un breve clip su WhatsApp: identifichiamo guasto e ricambi prima ancora di partire.",
  },
];

export default function GuaranteeBar() {
  return (
    <section className="bg-[#0A1329] py-14 sm:py-20" data-testid="guarantee-bar-container">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid gap-4 md:grid-cols-3">
          {ITEMS.map((item, i) => (
            <motion.div
              key={item.id}
              data-testid={`guarantee-item-${item.id}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.55, delay: i * 0.12 }}
              className="group rounded-xl border border-white/10 bg-[#0D1833] p-6 transition-all duration-300 hover:-translate-y-1 hover:border-[#FF5500]/45"
            >
              <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-lg bg-[#FF5500]/15 transition-colors duration-300 group-hover:bg-[#FF5500]">
                <item.icon className="h-6 w-6 text-[#FF5500] transition-colors duration-300 group-hover:text-white" strokeWidth={2.2} />
              </div>
              <h3 className="font-display text-xl font-bold uppercase tracking-tight">{item.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-400">{item.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
